// @flow
import React, { useRef, useEffect } from "react";
import { useTranslation } from "react-i18next";
import classnames from "classnames";

import TrustPilotFallbackLogo from "Commons/Assets/images/staticTrustPilotLogo.png";
import TrustPilotFallbackReview_01 from "Commons/Assets/images/staticTrustPilotReview_01.jpg";
import TrustPilotFallbackReview_02 from "Commons/Assets/images/staticTrustPilotReview_02.jpg";
import TrustPilotFallbackReview_03 from "Commons/Assets/images/staticTrustPilotReview_03.jpg";
import Styles from "./TrustPilotComponents.module.scss";

type Props = {
  theme?: string,
  className?: string,
  trustPilotRef?: Object,
  header?: string,
  templateId: string,
  height?: string,
  width?: string,
  id?: string,
  fallback?: "default" | "carrousel",
};

const TrustPilotWidget = ({
  trustPilotRef,
  className = "",
  theme,
  templateId,
  height = "",
  width = "100%",
  id,
  fallback = "default",
}: Props) => {
  const fallbackReviewImages = [TrustPilotFallbackReview_01, TrustPilotFallbackReview_02, TrustPilotFallbackReview_03];

  return (
    <div
      ref={trustPilotRef}
      className={classnames(className, "trustpilot-widget", Styles.container)}
      data-locale="de-DE"
      data-template-id={templateId}
      data-businessunit-id="5b572710f057fc000112f079"
      data-style-height={height ? height : null}
      data-style-width={width}
      data-theme={theme}
      data-stars="5"
      data-review-languages="de"
      id={id}
    >
      <a href="https://de.trustpilot.com/review/remind.me" target="_blank" rel="noopener noreferrer">
        {fallback === "default" && <img src={TrustPilotFallbackLogo} className={Styles.trustPilotFallbackImage} />}
        {fallback === "carrousel" && (
          <div className={Styles.imagesContainer}>
            {fallbackReviewImages.map((element, index) => (
              <div
                key={"trustPilotImageBlock_" + index}
                className={Styles.imageBlock}
                style={{
                  backgroundImage: `url('${element}')`,
                }}
              ></div>
            ))}
          </div>
        )}
      </a>
    </div>
  );
};

const useTrustPilot = () => {
  const trustPilotRef = useRef<?Element>(null);
  const { t } = useTranslation("trustPilot");
  // Loads the widget only when the Trust Pilot <script /> is loaded
  useEffect(() => window.Trustpilot?.loadFromElement(trustPilotRef?.current, true), []);
  return { trustPilotRef, t };
};

export { TrustPilotWidget, useTrustPilot };
